import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../App.js";
import Footer from "../components/footer";
import { Typography, Card, CardHeader, CardBody, CardFooter } from "@material-tailwind/react";
import { Link } from "react-router-dom";

const Infraestructura = () => {
  const [infraestructuraData, setInfraestructuraData] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("todas");

  useEffect(() => {
    axios
      .get(`${API_URL}infraestructura`)
      .then((response) => {
        const infraestructuraInfo = response.data.data.infraestructura;
        const categoriasInfo = response.data.data.categorias;
        setInfraestructuraData(infraestructuraInfo);
        setCategorias(categoriasInfo);
      })
      .catch((error) => {
        console.error("Error fetching infraestructura data:", error);
      });
  }, []);

  const infraestructuraFiltrada = categoriaSeleccionada === "todas"
    ? infraestructuraData
    : infraestructuraData.filter(item => item.categoria_id === parseInt(categoriaSeleccionada));

  return (
    <div className="flex flex-col flex-grow bg-gray-50">
      <br />

      <div className="container mx-auto px-4">
        {/* Filtros por categoría con contador */}
        <div className="flex flex-wrap justify-center gap-2 mb-6 mx-4">
          <button
            onClick={() => setCategoriaSeleccionada("todas")}
            className={`px-4 py-2 rounded-full font-sans font-medium transition-all duration-300 flex items-center gap-2 ${
              categoriaSeleccionada === "todas"
                ? "bg-colorPrincipal text-white shadow-lg"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            <span>Todas</span>
            <span className={`text-xs px-2 py-0.5 rounded-full ${
              categoriaSeleccionada === "todas"
                ? "bg-white/20"
                : "bg-gray-300"
            }`}>
              {infraestructuraData.length}
            </span>
          </button>
          {categorias.map((categoria) => {
            const count = infraestructuraData.filter(item => item.categoria_id === categoria.id).length;
            return (
              <button
                key={categoria.id}
                onClick={() => setCategoriaSeleccionada(categoria.id.toString())}
                className={`px-4 py-2 rounded-full font-sans font-medium transition-all duration-300 flex items-center gap-2 ${
                  categoriaSeleccionada === categoria.id.toString()
                    ? "bg-colorPrincipal text-white shadow-lg"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                <span>{categoria.nombre}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  categoriaSeleccionada === categoria.id.toString()
                    ? "bg-white/20"
                    : "bg-gray-300"
                }`}>
                  {count}
                </span>
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {infraestructuraFiltrada.map((item) => (
            <Link
              key={item.id}
              to={`/infraestructuraID/${item.id}`}
              className="block h-full no-underline"
            >
              <Card className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-full flex flex-col cursor-pointer">
                <CardHeader className="relative h-48 m-0 overflow-hidden flex-shrink-0">
                  <img
                    src={
                      item.ruta_imagen || process.env.PUBLIC_URL + "/Logo_AdaLab.png"
                    }
                    alt={item.nombre}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-3 right-3 bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm font-sans font-semibold">
                    {item.categoria_nombre}
                  </div>
                </CardHeader>
                <CardBody className="p-4 flex-grow">
                  <Typography
                    variant="h6"
                    color="blue-gray"
                    className="mb-2 font-sans font-bold"
                  >
                    {item.nombre}
                  </Typography>
                  <Typography className="text-sm font-sans text-gray-600 text-justify">
                    {item.descripcion.length > 150
                      ? `${item.descripcion.slice(0, 150)}...`
                      : item.descripcion}
                  </Typography>
                </CardBody>
                <CardFooter className="pt-0 px-4 pb-4">
                  <button className="w-full bg-[#1a365d] hover:bg-[#2d4a7c] text-white font-sans font-medium py-2.5 px-5 rounded-[25px] transition-all duration-300">
                    Ver detalles
                  </button>
                </CardFooter>
              </Card>
            </Link>
          ))}
        </div>

        {infraestructuraFiltrada.length === 0 && (
          <div className="bg-white rounded-xl shadow-md p-8 text-center">
            <Typography className="text-gray-500 font-sans">
              No hay equipos de infraestructura disponibles en esta categoría.
            </Typography>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Infraestructura;
